<template>
    <Fragment>
        <!-- Modal -->
        <div class="modal modal_inform" :id="'modelInform' + id" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">

                        <h5 class="modal-title title">Сообщение о поступлении товара</h5>
                        <button type="button" class="btn btn_lg btn_common btn_icononly" data-dismiss="modal" :id="'modelInformClose' + id"><i
                                class="f7-icons icon_lg">xmark</i></button>

                    </div>
                    <div class="modal-body">


                        <div class="info_title mt_xs">
                            Данная позиция отсутствует на складе. Мы можем сообщить Вам, если она появится в течение
                            следующих 60 дней.
                        </div>


                        <!-- cart_item -->
                        <div v-if="item" class="row cart_item underlined_item">
                            <div class="col-12 col-lg-8 mt_xxs">

                                <div class="media ki_group">
                                    <div class="ki_p">
                                        <template v-if="item.set_part">
                                            <div
                                                v-if="item.set_part == 'A'"
                                                class="cg_i item_icon item_icon_left"
                                            >
                                                <img src="/i/a.svg" alt="Часть A" />
                                            </div>
                                            <div
                                                v-if="item.set_part == 'B'"
                                                class="cg_i item_icon item_icon_left"
                                            >
                                                <img src="/i/b.svg" alt="Часть B" />
                                            </div>
                                            <div
                                                v-if="item.set_part == 'C'"
                                                class="cg_i item_icon item_icon_left"
                                            >
                                                <img src="/i/c.svg" alt="Часть C" />
                                            </div>
                                            <div
                                                v-if="item.set_part == 'D'"
                                                class="cg_i item_icon item_icon_left"
                                            >
                                                <img src="/i/d.svg" alt="Часть D" />
                                            </div>
                                        </template>

                                        <template v-else>
                                            <div
                                                v-if="item.is_new"
                                                class="cg_i item_icon item_icon_left"
                                            >
                                                <img src="/i/new.svg" alt="Новинка" />
                                            </div>
                                            <div
                                                v-if="item.is_bestseller"
                                                class="cg_i item_icon item_icon_left"
                                            >
                                                <img src="/i/hit.svg" alt="Новинка" />
                                            </div>
                                            <div
                                                v-if="item.is_sale"
                                                class="cg_i item_icon item_icon_left"
                                            >
                                                <img src="/i/sale.svg" alt="Новинка" />
                                            </div>
                                        </template>

                                        <a :href="'/catalog/item/' + item.slug">
                                            <div v-if="item.images.length > 0" 
                                                class="item_picture">
                                                    <div class="preview-image"
                                                        :style="
                                                            'background-image: url(/storage/' +
                                                            item.images[0].path
                                                        "
                                                    ></div>
                                            </div>
                                            <div v-else
                                                class="item_picture item_picture_no-image">
                                                    <div class="no-image"></div>
                                            </div>
                                        </a>
                                    </div>

                                    <div class="media-body">
                                        <div class="ki_title subtitle">
                                            <a :href="'/catalog/item/' + item.slug">{{
                                                item.full_title
                                                }}</a>
                                        </div>

                                        <div class="ki_info item_info item_info_horizontal">
                                            <p v-if="item.attr_color"><span>Цвет</span> {{ item.attr_color }}</p>
                                            <p v-if="item.attr_size"><span>Размер</span> {{ item.attr_size }}</p>
                                            <p v-if="item.attr_material"><span>Материал</span> {{ item.attr_material }}</p>
                                            <p v-if="item.attr_type"><span>Тип</span> {{ item.attr_type }}</p>
                                            <p v-if="item.country"><span>Производитель</span> {{ item.country }}</p>
                                            <p v-if="item.attr_other"><span>Прочее</span> {{ item.attr_other }}</p>
                                            <p><span>Артикул</span> {{ item.sku }}</p>
                                        </div>
                                        <div class="ki_small small_info">
                                            <span v-if="item.status == 1" class="stock_xs">В наличии.</span>
                                            <span v-else-if="item.status == 3"
                                                class="stock_some_xs">Заканчивается.</span>
                                            <span v-else-if="item.status == 2" class="stock_gone_xs">Нет в
                                                наличии.</span>
                                            <span v-else-if="item.status == 4" class="stock_request_xs">Под
                                                заказ.</span>
                                            <span v-else class="stock_gone_xs">Нет в наличии.</span>

                                            В упаковке по
                                            <span class="accent">{{ item.qty_per_pack }} {{ item.unit }}</span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="col-12 col-lg-4 mt_xxs">

                                <div class="ki_price">

                                    <span v-if="item.old_price && item.old_price !== item.price" class="other_lg">
                                        <s>{{ item.old_price }} р.</s>
                                    </span>

                                    <span class="price_lg">
                                        {{ item.price }} р.
                                    </span>

                                </div>

                            </div>
                        </div>
                        <!-- //cart_item -->

                        <form action="">
                            <div class="info_body mt_sm">

                                <div v-if="ok" class="alert alert-success" role="alert">
                                    Вы подписались на уведомления!
                                </div>

                                <div class="form-group">
                                    <label for="fb_01_2">Электронная почта</label>
                                    <input 
                                        type="email" 
                                        class="form-control" 
                                        id="fb_01_2" 
                                        v-model="email"
                                        @change.o="resetErrors"
                                        :class="{ 'is-invalid': errors.email }"
                                    >
                                </div>
                                <div class="form-group mt_sm">
                                    <div class="form-check">
                                        <input 
                                        class="form-check-input" 
                                        type="checkbox" 
                                        id="fb_01_3" 
                                        v-model="agree"
                                        @change.o="resetErrors"
                                        :class="{ 'is-invalid': errors.agree }"
                                        >
                                        <label class="form-check-label" for="fb_01_3">Даю согласие на обработку персональных
                                            данных</label>
                                    </div>
                                </div>

                                <button
                                    v-if="ok"
                                    type="button"
                                    class="btn btn_lg btn_neutral mt_xxs"
                                    data-dismiss="modal"
                                >
                                    Закрыть
                                </button>

                                <button
                                    v-else
                                    type="button"
                                    class="btn btn_lg btn_common mt_xxs"
                                    @click.prevent="send"
                                >
                                    Отправить
                                </button>

                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </div>
    </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";

export default {
    props: ["id", "email"],

    components: { Fragment },

    data: function () {
        return {
            item: null,
            agree: false,
            errors: {},
        };
    },

    computed: {
        ok() {
            return this.$store.state.informs.ok;
        }
    },

    methods: {
        send: function () {
            this.errors = {};

            let error = false;

            const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if (!this.email.length || !re.test(this.email)) {
                this.errors.email = 1;
                error = true;
            }

            if (!this.agree) {
                this.errors.agree = 1;
                error = true;
            }

            if (error) return;

            let params = {
                email: this.email,
                agree: this.agree,
                id: this.id
            };

            
            this.$store.dispatch('informs/addToInforms', params);

            setTimeout(() => {
                document.getElementById('modelInformClose' + this.id).click();
            }, 2000);
        },

        resetErrors: function (e) {
            this.errors = {};
        },
    },

    mounted() {
        axios.get("/ajax/catalog/item/" + this.id).then((request) => {
            if (
                typeof request.data.success != "undefined" &&
                request.data.success
            ) {
                this.item = request.data.data;
            }
        });
    }
};
</script>
